import { createBrowserRouter, redirect, type RouteObject } from 'react-router'
import App from '@/App'
import { RouteError, RouteLoading } from '@/components/RouteStatus'
import { createGuard } from './guard'
import { routes } from './routes'

/** Redirects keep the incoming query and hash unless the target sets its own (Vue Router behaviour). */
function redirectLoader (target: string | ((p: Record<string, string>) => string)) {
  return ({ request, params }: { request: Request; params: Record<string, string | undefined> }) => {
    const url = new URL(request.url)
    const clean: Record<string, string> = {}
    for (const [k, v] of Object.entries(params)) if (v !== undefined) clean[k] = v
    const dest = typeof target === 'function' ? target(clean) : target
    const keepQuery = !dest.includes('?') ? url.search : ''
    const keepHash = !dest.includes('#') ? url.hash : ''
    throw redirect(`${dest}${keepQuery}${keepHash}`)
  }
}

const children: RouteObject[] = routes.map((route) => {
  if (route.redirect) {
    return { path: route.path, loader: redirectLoader(route.redirect) }
  }
  return {
    path: route.path,
    handle: { name: route.name, meta: route.meta || {} },
    loader: createGuard(route),
    lazy: async () => {
      const mod = await route.page!()
      return { Component: mod.default }
    }
  }
})

export const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <RouteError />,
    hydrateFallbackElement: <RouteLoading />,
    children
  }
])
